import { imagePositionStyle } from "../lib/imagePosition";

interface ProductImageProps {
  imageUrl: string | null;
  title: string;
  imageScale?: number;
  imageOffsetX?: number;
  imageOffsetY?: number;
}

export function ProductImage({ imageUrl, title, imageScale = 1, imageOffsetX = 0, imageOffsetY = 0 }: ProductImageProps) {
  if (imageUrl) {
    return (
      <div className="product-image-bg w-full aspect-[4/3] overflow-hidden relative">
        <img
          className="w-full h-full object-cover"
          src={imageUrl}
          alt={title}
          draggable={false}
          style={imagePositionStyle(imageScale, imageOffsetX, imageOffsetY)}
        />
      </div>
    );
  }

  return <div className="product-image-bg w-full aspect-[4/3]" />;
}

export function sourceLabelFor(url: string): string {
  try {
    const hostname = new URL(url).hostname;
    return hostname.startsWith("www.") ? hostname.slice(4) : hostname;
  } catch {
    return url;
  }
}
